var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlurredToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 624"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    filterUnits: "objectBoundingBox",
    id: "blurred-toggle_svg__a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-2.4%",
    y: "-5.2%",
    width: "104.9%",
    height: "110.3%",
    filterUnits: "objectBoundingBox",
    id: "blurred-toggle_svg__b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "107.469%",
    x2: "0%",
    y2: "-2.569%",
    id: "blurred-toggle_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081125",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A5668",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.566,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#80AFE5",
    opacity: 0.702,
    filter: "url(#blurred-toggle_svg__a)",
    cx: 91,
    cy: 29,
    r: 15
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#7DABE0",
    strokeWidth: 3,
    opacity: 0.557,
    filter: "url(#blurred-toggle_svg__b)",
    x: 1.5,
    y: 1.5,
    width: 120,
    height: 55,
    rx: 27.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.25 58c0 303.459.083 490.644.25 561.557",
    stroke: "url(#blurred-toggle_svg__c)",
    strokeWidth: 3,
    strokeLinecap: "square",
    transform: "matrix(-1 0 0 1 125 2)"
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgBlurredToggle as ReactComponent };